import React, { Component } from 'react';

const withDeviceOrientation = (WrappedComponent) => class DeviceOrientation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orientation: 'landscape',
    };
  }

  componentWillMount() {
    this.onOrientationChange(null);
  }

  componentDidMount() {
    if ((window.screen.orientation) && ('onchange' in window.screen.orientation)) {
      window.screen.orientation.addEventListener('change', this.onOrientationChange);
    } else if ('onorientationchange' in window) {
      window.addEventListener('orientationchange', this.onOrientationChange);
    }
  }

  componentWillUnmount() {
    if ((window.screen.orientation) && ('onchange' in window.screen.orientation)) {
      window.screen.orientation.removeEventListener('change', this.onOrientationChange);
    } else if ('onorientationchange' in window) {
      window.removeEventListener('orientationchange', this.onOrientationChange);
    }
  }

  onOrientationChange = () => {
    let orientation = 'landscape';
    if (window.orientation !== void 0) {
      orientation = Math.abs(window.orientation) === 90 ? 'landscape' : 'portrait';
    }

    if (window.screen.orientation || window.screen.mozOrientation || window.screen.msOrientation) {
      [orientation] = (
        (window.screen.orientation || {}).type ||
        window.screen.mozOrientation ||
        window.screen.msOrientation
      ).split('-');
    }
    this.setState({
      orientation,
    });
  }

  render() {
    const { orientation } = this.state;
    return (
      <WrappedComponent
        {...this.props}
        isPortrait={orientation === 'portrait'}
      />
    );
  }
};

export default withDeviceOrientation;
